export const generateAiInsights = async (payload: any) => {
    try {
        // Fetch JWT token to pass in the Authorization header
        let token = ''
        try {
            const { getOrWaitForAuthToken } = await import('./firebase')
            token = (await getOrWaitForAuthToken()) || ''
        } catch (e) {
            console.warn('[AI] Could not fetch auth token for AI insights')
        }

        const response = await fetch('/api/ai/insights', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {})
            },
            body: JSON.stringify(payload),
        })

        if (!response.ok) {
            const errBody = await response.text()
            console.error('[AI] Backend AI Error:', response.status, errBody)
            return { success: false, error: 'Failed to fetch AI insights' }
        }

        const data = await response.json()
        return data
    } catch (error: any) {
        console.error('[AI] Insight Generation Error:', error)
        return { success: false, error: error.message }
    }
}
